// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import {map} from 'lodash';
import classnames from 'classnames';

// Components
import Error from '../core/error';
import MultiSelect from '../core/multi-select';

// Containers
import withSearch from '../../containers/with-search';

function ProviderSelect(props) {
    const {className, error, searchData, fetched, label = 'Provider', name = 'provider.partnerId', multi = true, validate} = props;

    const getClass = () =>
        classnames(
            {
                'provider-select': true,
            },
            className
        );

    const getOptions = (providers) =>
        map(providers, (provider) => ({
            value: provider.partnerId,
            label: provider.name.split('_').join(' '),
        }));

    const renderSelect = () => {
        let content = null;

        if (!error) {
            content = (
                <MultiSelect
                    disabled={!fetched || !searchData.length}
                    label={label}
                    multi={multi}
                    name={name}
                    operator="=in="
                    options={getOptions(searchData)}
                    placeholder="Filter by Provider"
                    validate={validate}
                />
            );
        }

        return content;
    };

    return (
        <div className={getClass()}>
            <Error error={error} />
            {renderSelect()}
        </div>
    );
}

ProviderSelect.propTypes = {
    className: PropTypes.string,
    error: PropTypes.string,
    fetched: PropTypes.bool.isRequired,
    label: PropTypes.string,
    multi: PropTypes.bool,
    name: PropTypes.string,
    searchData: PropTypes.array,
    validate: PropTypes.array,
};

export default withSearch(ProviderSelect, 'providersSelect');
